<template>
  <div class="contact">
    <p class="text__bold">{{ contact.title }}</p>
    <p>{{ contact.name }}</p>
    <p>{{ contact.email }}</p>
  </div>
</template>

<script>
export default {
  props: ["contact"]
};
</script>

<style scoped>
</style>